import BRANDS from "@elit-hair/brands";
import { Button, Icon } from "@elit-hair/elit-ui";
import { t } from "i18next";
import { ComponentProps, ReactNode, forwardRef } from "react";
import { TbExternalLink } from "react-icons/tb";

import { useCall } from "@/providers/hooks/use-call";
import { getZohoCrmUrl } from "@/utils/get-zoho-crm-url";

export type OpenRecordButtonProps = {
    id?: string | number;
    moduleType?: string;
    brand?: keyof typeof BRANDS;
    label?: ReactNode;
    icon?: ReactNode;
    disabled?: boolean;
    className?: string;
    size?: ComponentProps<typeof Button>["size"];
};

export const OpenRecordButton = forwardRef<HTMLButtonElement, OpenRecordButtonProps>(
    (
        {
            id,
            moduleType,
            brand,
            label = (
                <p>
                    {t("open_in_crm")} <Icon icon={TbExternalLink} />
                </p>
            ),
            icon,
            disabled,
            className,
            size,
        },
        ref
    ) => {
        const { selectedBrand } = useCall();
        const handleClick = () => {
            const url = getZohoCrmUrl(brand ?? selectedBrand ?? undefined, moduleType, id);
            if (url) {
                window.open(url, "_blank");
            }
        };
        return (
            <Button
                ref={ref}
                variant="outline"
                size={size}
                className={className}
                onClick={handleClick}
                disabled={disabled || !id || !moduleType}
            >
                {icon}
                {label}
            </Button>
        );
    }
);
